<template>
  <VDialogV3
    ref="dialog"
    id="order-create-dialog-minimized"
    position="right"
    width="600px"

    :entity="localOrder"
    :edit-button-disable="true"
    :context-menu="null"
    title="Оформление заказа"
  >
    <article class="order-type-wrap">
      <VCheckboxGroup
        checkbox-layout="buttons"
        :disabled="showConfirm === true || orderTypeList.length === 1"
        type-radio
        :options="orderTypeList"
        option-label="name"
        :value="orderType"
        @update:modelValue="onInputOrderType"
      />
    </article>

    <section class="order-info">
      <header>Общая информация</header>
      <dl>
        <dt>Наименование сырья:</dt>
        <dd>
          {{ (tender?.productCategory ?? offer?.productCategory)?.name }}
        </dd>
      </dl>
      <dl>
        <dt>Доступно:</dt>
        <dd>
          {{ (tenderBid?.qtyLeft ?? offer?.qtyLeft)?.format(localOrder.positions[0].unit) ?? '--' }}
        </dd>
        <dt>Упаковка:</dt>
        <dd>{{
            (tenderBid?.packageVolume ?? offer?.packageVolume)?.format(localOrder.positions[0].unit)
          }}. {{ tenderBid?.package?.name ?? offer?.package?.name ?? '' }}
        </dd>
      </dl>
      <dl>
        <dt>Дней доставки:</dt>
        <dd>{{ localOrder.deliveryDays }}
          {{ $core.utils.regional.ru.pluralize(localOrder.deliveryDays, 'день', 'дня', 'дней') }}
        </dd>
      </dl>
      <dl v-if="offer?.isAcceptingPreorder === true">
        <dt>Доступен предзаказ от:</dt>
        <dd>{{ preorderMinQty?.format(localOrder.positions[0]?.unit) }}</dd>
      </dl>
      <dl v-if="offer?.isAcceptingPreorder === true">
        <dt>Страховой запас:</dt>
        <dd>{{ preorderMonthlyReserve?.format(localOrder.positions[0]?.unit) }}</dd>
      </dl>
      <dl>
        <dt>Описание:</dt>
        <dd>{{ tenderBid?.description || offer?.description || '--' }}</dd>
      </dl>
    </section>
    <hr>

    <section>
      <VInput
        label="Продавец"
        required
        disabled
        :value="localOrder.seller.name"
      />

      <VInput
        label="Юр. лицо"
        required
        disabled
        :value="localOrder.sellerCompany.name"
      />

      <VSelectV2
        v-model="localOrder.sellerStore"
        label="Склад отправки"
        required
        hide-clear-btn
        :data="sellerStoresSource"
      />
    </section>
    <hr>

    <section>
      <VInput
        v-model="localOrder.buyer.name"
        label="Покупатель"
        required
        disabled
      />

      <VSelectV2
        v-model="localOrder.buyerCompany"
        label="Юр. лицо"
        required
        :disabled="showConfirm"
        :data="buyerCompanySource"
      />

      <VSelectV2
        v-model="localOrder.buyerStore"
        label="Склад получения"
        required
        :disabled="showConfirm"
        :data="buyerStoreSource"
      />

      <VSelectV2
        v-if="localOrder.buyer.isNamangan === true || localOrder.buyer.isLSZ === true"
        v-model="localOrder.buyerProductionSite"
        label="Производственная площадка"
        required
        :disabled="showConfirm"
        :data="productionSiteSource"
        validate-options
      />
    </section>
    <hr>

    <section>
      <VSelectV2
        v-model="localOrder.positions[0].product"
        searchable
        label="Товар"
        option-label="name"
        :minimum-input-length="0"
        :data="productSource"
        :disabled="showConfirm"
        required
      >
        <template #option="{ option }">
							<span
                class="title ellipsis"
                :title="option.name"
              >{{ option.name }}</span>
          <span class="description">Артикул: {{ option.code }}</span>
        </template>
      </VSelectV2>

      <VSelectV2
        required
        label="Категория"
        disabled
        v-model="localOrder.positions[0].productCategory"
      />

      <VInputV2
        required
        label="Артикул"
        :max-length="150"
        disabled
        v-model="localOrder.positions[0].buyersCode"

        :depends-on="() => localOrder.positions[0].product"
        :default="(product) => product.code"
      />

      <VInput
        v-model="localOrder.positions[0].name"
        label="Наименование товара в ИС поставщика"
        disabled
        required
        :max-length="175"
      />

      <VSelectV2
        v-model="localOrder.positions[0].manufacturer"
        label="Производитель"
        hide-clear-btn
        disabled
        :data="manufacturerList"
        required
      />

      <VDateInput
        v-model="localOrder.positions[0].productExpirationDate"
        label="Срок годности"
        disabled
        required
      />

      <div>
        <VFormItem
          label="Ссылка (номер макета)"
        >
          <VInput
            v-model="localOrder.positions[0].layoutFile"
            :disabled="showConfirm"
          />
          <VLink
            title="Копировать"
            @click="copyLink"
          >
            <template #icon>
              <VIcon
                material="content_copy"
                theme="outlined"
              />
            </template>
          </VLink>
        </VFormItem>
      </div>
    </section>
    <hr>

    <section class="section-price">
      <VInputNumberRusV2
        v-model="localOrder.positions[0].qty"
        :type="Qty"
        class="qty-input"
        :unit="localOrder.positions[0].unit"
        :label="'Кол-во, ' + localOrder.positions[0].unit?.toString()"
        show-buttons
        :disabled="showConfirm"
        required
        :validate-method="validateQty"
      >
        <template #helper-text>
          <ul v-if="$core.utils.isNotEmptyArray(tender?.bids)">
            <li
              v-for="([key, value]) in Object.entries(tender.getAvailableQtysForOrder(localOrder.positions[0].packageVolume))"
              :key="key"
            >
              Заказать {{ key }}
              <VLink
                @click="localOrder.positions[0].qty = value"
              >
                установить {{ value }} {{ localOrder.positions[0].unit?.toString() }};
              </VLink>
            </li>
          </ul>
        </template>
      </VInputNumberRusV2>

      <!-- Второму покупателю цена поставщика не показывается — только его собственная -->
      <VFormItem
        v-if="$core.currentPartner.isSecondaryBuyer === false"
        label="Цена"
        with-asterisk
        :unit="localOrder.positions[0].unit"
      >
        <VInputNumberRusV2
          disabled
          required
          v-model="localOrder.positions[0].priceSeller"
          :type="Price"
        />

        <VSelectV2
          hide-clear-btn
          disabled
          option-label="symbol"
          required
          :data="$core.currencies.currencies"
          v-model="currencyCode"
        />
      </VFormItem>

      <VFormItem
        with-asterisk
        :label="$core.currentPartner.isSecondaryBuyer === true ? 'Полная цена для покупателя' : 'Полная цена'"
        :unit="localOrder.positions[0].unit"
      >
        <VInputNumberRusV2
          :model-value="$core.currentPartner.isSecondaryBuyer === true ? localOrder.positions[0].priceFullBuyer : localOrder.positions[0].priceFullSeller"
          :type="Price"
          disabled
          autocomplete="off"
          required
        />

        <!-- Контрол цены выше скрыт, а валюта нужна всегда — рисуем её здесь -->
        <VSelectV2
          v-if="$core.currentPartner.isSecondaryBuyer === true"
          hide-clear-btn
          disabled
          option-label="symbol"
          required
          :data="$core.currencies.currencies"
          v-model="currencyCode"
        />
      </VFormItem>

      <VFormItem
        v-if="localOrder.sellerCompany.isVatPayer === true"
      >
        <VSwitch
          label="НДС"
          disabled
          checked-label="включительно"
          unchecked-label="сверху"
          theme="slider"
          v-model="localOrder.positions[0].isVatIncludedSeller"
        />

        <VInputNumberRusV2
          label="Ставка"
          disabled
          v-model="localOrder.positions[0].vatRateSeller"
          :type="VatRate"
        />
      </VFormItem>

      <VInput
        v-else
        label="НДС"
        disabled
        value="Не облагается"
      />

      <VFormItem
        v-if="localOrder.isRawMaterialsAndPackage"
      >
        <VInputNumberRusV2
          v-model="localOrder.positions[0].packageVolume"
          :type="Qty"
          label="Фасовка"
          autocomplete="off"
          required
          disabled
        />

        <VInput
          v-model="localOrder.positions[0].unit.name"
          label="Ед. изм."
          disabled
          hide-clear-btn
          required
        />
      </VFormItem>

      <span><b>Итого: </b> {{ totalPriceText }}</span>
    </section>
    <hr>

    <section>
      <VSelectV2
        v-model="localOrder.deliveryType"
        label="Тип доставки"
        disabled
        :data="$core.dictionaries.deliveryTypes"
        hide-clear-btn
        required
      />

      <VDateRangeInputNew
        v-if="localOrder.isPreorder === true"
        ref="preorderShipmentPeriodInput"
        label="Период доставки"
        required
        :disabled="showConfirm"
        :validate-method="validatePreorderShipmentPeriod"
        v-model="localOrder.positions[0].preorderShipmentPeriod"
      >
        <template #helper-text>
          Интервал поставки с {{ $core.utils.date.format(receiptPeriod.start) }} по
          {{ $core.utils.date.format(receiptPeriod.end) }}
        </template>
      </VDateRangeInputNew>

      <div v-else>
        <VDateInput
          ref="desiredReceiptDateInput"
          label="Желаемая дата доставки"
          :disabled="showConfirm"
          required
          :validate-method="validateDesiredReceiptDate"
          :value="localOrder.positions[0].desiredReceiptDate"
          @input="onInputDesiredReceiptDate"
        >
          <template #helper-text>
            Интервал получения {{ receiptPeriod.toString() }}
            <br>
            <template v-if="localOrder.positions[0].desiredReceiptDate">
              <div
                v-if="$core.utils.date.isWeekend(localOrder.positions[0].desiredReceiptDate)"
                class="warning"
              >
                Выпадает на выходной ({{
                  $core.utils.date.getWeekDayName(localOrder.positions[0].desiredReceiptDate, true, true)
                }})
              </div>
              <div v-else>
                {{ $core.utils.date.getWeekDayName(localOrder.positions[0].desiredReceiptDate) }}
              </div>
            </template>
            <template v-else>
              --
            </template>
          </template>
        </VDateInput>

        <VDateInput
          ref="plannedShipmentDateInput"
          label="Планируемая дата отгрузки"
          :disabled="showConfirm"
          required
          :value="localOrder.positions[0].plannedShipmentDate"
          :validate-method="validatePlannedShipmentDate"
          @input="onInputPlannedShipmentDate"
        >
          <template #helper-text>
            <template v-if="localOrder.positions[0].plannedShipmentDate">
              <div
                v-if="$core.utils.date.isWeekend(localOrder.positions[0].plannedShipmentDate)"
                class="warning"
              >
                Выпадает на выходной ({{
                  $core.utils.date.getWeekDayName(localOrder.positions[0].plannedShipmentDate, true, true)
                }})
              </div>
              <div v-else>
                {{ $core.utils.date.getWeekDayName(localOrder.positions[0].plannedShipmentDate) }}
              </div>
            </template>
            <template v-else>
              --
            </template>
          </template>
        </VDateInput>
      </div>
    </section>
    <hr>

    <PaymentTermEditor
      :entity="localOrder"
      :disabled="showConfirm"
    />
    <hr>

    <section>
      <VSelectV2
        v-model="localOrder.responsibleBuyer"
        label="Ответственный"
        :disabled="showConfirm"
        placeholder="Введите ФИО ответственного"
        hide-clear-btn
        :data="({pattern}) => PersonsService.searchPersons(pattern, localOrder.buyer.id)"
        required
      />
    </section>

    <template #footer>
      <div :class="{ 'justify-between': showConfirm === false }">
        <div
          v-if="showConfirm === true"
          class="info-wrap"

        >
          <div class="confirm-block">
            <VIcon material="warning_amber"/>
            <span>
							Вы собираетесь оформить заказ<br>
							на <b>сумму
              <template v-if="$core.currentPartner.isSecondaryBuyer">
              {{ localOrder.positions[0].sumFullBuyer.format(localOrder.currencyCode) }}
              </template>
              <template v-else>
                {{ localOrder.positions[0].sumFullSeller.format(localOrder.currencyCode) }}
              </template>
              </b>
              <br>
							Проверьте данные и подтвердите операцию
						</span>
          </div>
        </div>

        <template v-if="showConfirm === true">
          <VButton
            theme="primary"
            :disabled="isSaveDisabled"
            @click="createOrder"
          >
            Оформить {{ orderType?.name?.toLowerCase() ?? '--' }}
          </VButton>

          <VButton
            class="cancel-btn"
            @click="showConfirm = false"
          >
            Назад
          </VButton>
        </template>

        <template v-else>
          <VButton
            theme="primary"
            :disabled="isLoading"
            @click="startCreateEntity"
          >
            Начать оформление
          </VButton>

          <VButton
            class="cancel-btn"
            @click="$core.dialogs.OrderCreateDialogMinimized.hide()"
          >
            Отмена
          </VButton>
        </template>
      </div>
    </template>
  </VDialogV3>
</template>

<style lang="scss" src="./OrderCreateDialogMinimized.scss"/>

<script lang="ts">
import DateRange from '@/core/types/DateRange';
import DateSimple from '@/core/types/DateSimple';
import Tender from '@/domains/Tenders/Tender';
import TenderBid from '@/domains/TenderBids/TenderBid';
import Order from "@/domains/Orders/Order";
import Preorder from "@/domains/Preorders/Preorder";
import OrdersService from "@/domains/Orders/OrdersService";
import ProductsService from '@/domains/Products/ProductsService';
import PaymentTermEditor
  from '@/domains/PaymentTerms/components/PaymentTermEditor/PaymentTermEditor.vue';
import PersonsService from "@/domains/Persons/PersonsService";
import Qty from "@/core/types/Qty";
import Offer from "@/domains/Offers/Offer";
import Demand from "@/domains/Demand/Demand";
import Price from "@/core/types/Price";
import VatRate from "@/core/types/VatRate";
import StoresService from "@/domains/Stores/StoresService";
import CompaniesService from "@/domains/Companies/CompaniesService";
import Manufacturer from "@/domains/Manufacturers/Manufacturer";
import Product from "@/domains/Products/Product";
import ProductionSitesService from "@/domains/ProductionSites/ProductionSitesService";

type OrderTypeOption = {
  id: 'order' | 'preorder' | 'samples';
  name: string;
};

export default defineComponent({
  name: 'OrderCreateDialogMinimized',

  components: {
    PaymentTermEditor,
  },

  props: {
    showOrderType: {
      type: Boolean,
      default: false,
    },
    offer: {
      type: Object as PropType<Offer>,
      default: null,
    },
    demand: {
      type: Object as PropType<Demand>,
      default: null,
    },
    preorder: {
      type: Object as PropType<Preorder>,
      default: null,
    },
    /** Если заказ создатся в результате выбора ставки из тендера */
    tender: {
      type: Object as PropType<Tender>,
      default: null,
    },
    tenderBid: {
      type: Object as PropType<TenderBid>,
      default: null,
    },
  },

  /**
   * setup используется для проброса классов в template
   * без оборачивания в reactive proxy.
   *
   * Если положить классы в data(), Vue рекурсивно обернёт их в Proxy —
   * бессмысленная нагрузка на реактивную систему для статических сервисов.
   */
  setup() {
    return {
      ProductsService,
      PersonsService,
      VatRate,
      Price,
      Qty,
    };
  },

  data() {
    const localOrder = this.createEntity();
    return {
      localOrder,

      showConfirm: false,
      /** isLoading заканчивается, и можно успеть нажать на кнопку,
       * поэтому isLoading обнуляем после закрытия диалога */
      isLoading: false,

      /**
       * Склады продавца. Для заказов из тендера дополнительно фильтруются
       * по транспортной зоне склада, указанного в ставке.
       */
      sellerStoresSource: this.$core.loader.select(({seller}) => {
        const params: any = {
          partnerId: seller.id,
        };

        if (this.tender instanceof Tender && this.tenderBid?.sellerStore?.transportZone?.id) {
          params.transportZoneId = this.tenderBid.sellerStore.transportZone.id;
        }

        return StoresService.getList(params);
      })
        .dependsOn({seller: () => this.localOrder.seller})
        .preloadOnMount(),

      /** Юрлица покупателя. */
      buyerCompanySource: this.$core.loader.select(({buyer}) =>
        CompaniesService.getList({partnerId: buyer.id})
      )
        .dependsOn({buyer: () => this.localOrder.buyer})
        .default((options) => options.find(_option => _option.id === 66))
        .preloadOnMount(),

      /** Склады получения покупателя, по умолчанию — склад юрлица. */
      buyerStoreSource: this.$core.loader.select(({buyer}) =>
        StoresService.getList({partnerId: buyer.id})
      )
        .dependsOn({
          buyer: () => this.localOrder.buyer,
          buyerCompany: () => this.localOrder.buyerCompany,
        })
        .default((options, {buyerCompany}) =>
          options.find(_option => _option.id === buyerCompany?.defaultStore?.id)
        )
        .preloadOnFocus(),

      /** Товары по категории: грузятся по выбранной productCategory, зависимый источник. */
      productSource: this.$core.loader.select<Product>(({productCategory, pattern}) =>
        ProductsService.getList({category: {id: productCategory.id}, pattern})
      )
        .dependsOn({productCategory: () => this.localOrder.tender?.productCategory ?? this.localOrder.positions[0].productCategory})
        .preloadOnMount(),

      /**
       * Площадки принадлежат юрлицу покупателя, а оно в карточке
       * редактируемое — поэтому dependsOn, а не разовая догрузка в init:
       * при смене юрлица список перезагрузится сам. Прежняя схема грузила
       * площадки один раз для исходного юрлица, и после его смены селект
       * молча пустел.
       */
      productionSiteSource: this.$core.loader.select(({buyerCompany}) =>
        ProductionSitesService.getList(null, buyerCompany)
      )
        .dependsOn({buyerCompany: () => this.localOrder.buyerCompany})
        .default((options) => options.find(_option => _option.id === "berdsk"))
        .preloadOnFocus(),
    };
  },

  computed: {
    orderType(): OrderTypeOption {
      if (this.localOrder.isPreorder === true) {
        return {id: 'preorder', name: 'Предзаказ'};
      }

      if (this.localOrder.isSamples === true) {
        return {id: 'samples', name: 'Образец'};
      }

      return {id: 'order', name: 'Заказ'};
    },

    currencyCode: {
      set({value}: any) {
        this.localOrder.currencyCode = value;
      },
      get(): any {
        return this.$core.utils.money.getCurrencyByCode(this.localOrder.currencyCode);
      },
    },

    isValid(): boolean {
      return this.$refs?.dialog?.formRef.isValid ?? false;
    },

    isSaveDisabled(): boolean {
      return this.isValid === false || this.isLoading === true;
    },

    manufacturerList(): Manufacturer[] {
      if (this.$core.utils.isNullOrUndefined(this.localOrder.positions[0].manufacturer) === true) {
        return [];
      } else {
        return [this.localOrder.positions[0].manufacturer];
      }
    },

    /** Минимальное количество для предзаказа */
    preorderMinQty(): Qty | null {
      if (this.offer?.isAcceptingPreorder !== true) {
        return null;
      }
      if (this.tender instanceof Tender) {
        return this.localOrder.positions[0].preorderMinQty;
      } else {
        return this.offer?.preorderMinQty ?? null;
      }
    },

    /** Страховой запас на складе по предзаказу */
    preorderMonthlyReserve(): Qty | null {
      if (this.offer?.isAcceptingPreorder !== true) {
        return null;
      }
      if (this.tender instanceof Tender) {
        return this.localOrder.positions[0].preorderMonthlyReserve;
      } else {
        return this.offer?.preorderMonthlyReserve ?? null;
      }
    },

    /**
     * Итог по позиции. Считается по той же стороне сделки, что показана
     * в контролах цены, — иначе цифры в форме и в итоге разъедутся.
     */
    totalPriceText(): string {
      if (this.$core.currentPartner.isSecondaryBuyer === true) {
        if (this.localOrder.positions[0].priceFullBuyer?.isEmpty() === false && this.localOrder.positions[0].qty?.isEmpty() === false && this.localOrder.positions[0].currencyCode) {
          return `${this.localOrder.positions[0].sumFullBuyer.format(this.localOrder.positions[0].currencyCode)}, в том числе НДС ${this.localOrder.positions[0].vatSumBuyer.format(this.localOrder.positions[0].currencyCode)}`;
        } else {
          return 'Введите цену, валюту и количество';
        }
      } else {
        if (this.localOrder.positions[0].priceFullSeller?.isEmpty() === false && this.localOrder.positions[0].qty?.isEmpty() === false && this.localOrder.positions[0].currencyCode) {
          return `${this.localOrder.positions[0].sumFullSeller.format(this.localOrder.positions[0].currencyCode)}, в том числе НДС ${this.localOrder.positions[0].vatSumSeller.format(this.localOrder.positions[0].currencyCode)}`;
        } else {
          return 'Введите цену, валюту и количество';
        }
      }
    },

    /**
     * Список доступных типов заказа для переключателя.
     *
     * - «Заказ» доступен для сырья/упаковки, если это не образец и тендер не требует предзаказ
     * - «Образец» доступен если оффер помечен как образец
     * - «Предзаказ» доступен если из оффера можно сделать предзаказ, или тендер требует предзаказ
     */
    orderTypeList(): OrderTypeOption[] {
      const result: OrderTypeOption[] = [];

      const isTenderRequiresPreorder = this.tender instanceof Tender && this.tender.isPreorderNeeded === true;

      const canCreateOrder =
        /** Только для категории «Сырьё и упаковка» */
        this.localOrder.isRawMaterialsAndPackage && this.localOrder.isSamples === false
        /** Если тендер требует предзаказ — обычный заказ недоступен */
        && isTenderRequiresPreorder === false;

      const canCreatePreorder =
        /** Оффер явно разрешает предзаказ */
        this.offer?.isAcceptingPreorder === true
        /** Тендер требует предзаказ */
        || isTenderRequiresPreorder;

      if (canCreateOrder === true) {
        result.push({id: 'order', name: 'Заказ'});
      }

      if (this.localOrder.isSamples === true) {
        result.push({id: 'samples', name: 'Образец'});
      }

      if (canCreatePreorder === true) {
        result.push({id: 'preorder', name: 'Предзаказ'});
      }

      return result;
    },

    product(): Product {
      if (this.tender instanceof Tender) {
        return this.tender.product;
      } else {
        return Product.getEmpty();
      }
    },

    receiptPeriod(): DateRange {
      if (this.localOrder.isPreorder === true) {
        /** Если мы оформляем предзаказ, то "период получения" на самом деле это период отгрузки
         * и с периодом отгрузки мы ничего не делаем, а просто говорим пользователю что нужен вот такой вот период */
        if (this.tender instanceof Tender) {
          return this.tenderBid.shipmentPeriod;
        } else {
          return this.offer!.shipmentPeriod;
        }
      } else {
        /** order / samples */
        if (this.tender instanceof Tender) {
          return this.tenderBid.receiptPeriod;
        } else {
          return this.offer!.receiptPeriod;
        }
      }
    },
  },

  mounted() {
    /** В конструкторе поля дат были проинициализированы, и на момент маунта нужно
     * сразу провалидировать */
    this.validateDatesOnMount();
  },

  methods: {

    // ======= Инициализация =======

    /**
     * Создаёт localOrder на основании входных пропсов.
     * Используется при инициализации и при переключении типа заказа.
     */
    createEntity(orderTypeId?: string): Order {
      if (this.tender) {
        if (this.tender.isPreorderNeeded === true) {
          return Preorder.fromTenderBid(this.tenderBid, this.tender);
        }
        return Order.fromTenderBid(this.tenderBid, this.tender);
      }

      if (this.demand) {
        if (this.demand.isPreorderNeeded === true || orderTypeId === 'preorder') {
          return Preorder.fromOffer(this.offer);
        }
        return Order.fromOffer(this.offer, this.demand);
      }

      if (orderTypeId === 'preorder') {
        return Preorder.fromOffer(this.offer);
      }

      return Order.fromOffer(this.offer, this.demand);
    },

    // ======= Переключение типа заказа =======

    onInputOrderType(value: OrderTypeOption): void {
      if (value.id === this.orderType.id) {
        return;
      }

      this.localOrder = this.createEntity(value.id);
    },

    // ======= Валидация дат =======

    /**
     * В конструкторе поля дат были проинициализированы, и на момент маунта нужно
     * сразу провалидировать
     */
    validateDatesOnMount(): void {
      const isPreorderNeeded = (this.tender instanceof Tender && this.tender.isPreorderNeeded === true)
        || (this.demand?.isPreorderNeeded === true);

      if (isPreorderNeeded === true) {
        /** если в конструкторе не было инициализировано поле, то
         * валидировать контролы не нужно */
        if (!this.localOrder.positions[0].preorderShipmentPeriod) {
          return;
        }
        (this.$refs.preorderShipmentPeriodInput as any)?.validateForce();
      } else {
        /** если в конструкторе не были инициализированы поля plannedShipmentDate и desiredReceiptDate, то
         * валидировать контролы не нужно */
        if (!this.localOrder.positions[0].plannedShipmentDate && !this.localOrder.positions[0].desiredReceiptDate) {
          return;
        }
        (this.$refs.plannedShipmentDateInput as any)?.validateForce();
        (this.$refs.desiredReceiptDateInput as any)?.validateForce();
      }
    },

    validateDesiredReceiptDate(value: any): string | null {
      if (!value) {
        return null;
      }

      if (this.localOrder.isPreorder === true) {
        return null;
      }

      const today = this.$core.utils.date.toDayStart(new Date());

      if (value <= today) {
        return 'Нельзя указать прошедшую дату';
      }

      if (!this.receiptPeriod.contains(value)) {
        return 'Вне интервала получения';
      }

      return null;
    },

    validatePlannedShipmentDate(value: any): string | null {
      if (!value) {
        return null;
      }

      const today = this.$core.utils.date.toDayStart(new Date());

      if (value <= today) {
        return 'Нельзя указать прошедшую дату';
      }

      return null;
    },

    validatePreorderShipmentPeriod(value: any): string | null {
      if (!value) {
        return null;
      }

      if (this.receiptPeriod.contains(value)) {
        return null;
      }

      return 'Недопустимый период';
    },

    validateQty(value: Qty): string | null {
      const packageVolume = this.localOrder.positions[0].packageVolume;

      let minQty;

      if (this.offer?.isAcceptingPreorder === true && this.localOrder.isPreorder === true) {
        minQty = this.localOrder.preorderMinQty;
      } else {
        minQty = packageVolume;
      }

      return this.$core.utils.number.validateDesiredQty(
        value,
        packageVolume,
        undefined,
        minQty,
        this.localOrder.positions[0].unit?.toString(),
      );
    },

    // ======= Обработка ввода дат =======

    /* fixme По хорошему эту всю логику спрятать */
    onInputDesiredReceiptDate(value: any): void {
      this.localOrder.positions[0].desiredReceiptDate = new DateSimple(value);
      this.localOrder.positions[0].plannedShipmentDate = this.localOrder.positions[0].desiredReceiptDate.subtract({days: this.localOrder.deliveryDays});

      (this.$refs.plannedShipmentDateInput as any)?.validateForce();
    },

    onInputPlannedShipmentDate(value: any): void {
      this.localOrder.positions[0].plannedShipmentDate = new DateSimple(value);
      this.localOrder.positions[0].desiredReceiptDate = this.localOrder.positions[0].plannedShipmentDate.add({days: this.localOrder.deliveryDays});

      (this.$refs.desiredReceiptDateInput as any)?.validateForce();
    },

    // ======= Действия =======

    async startCreateEntity(): Promise<void> {
      if (await this.$refs?.dialog?.validateAndFocus() === false) {
        return;
      }

      this.showConfirm = true;
    },

    async createOrder(): Promise<void> {
      const confirmed = await this.$core.confirm(
        `Вы создаете заказ с пунктом отправки: ${this.localOrder.sellerStore.toString()}. Подтверждаете?`,
      );

      if (confirmed === false) {
        return;
      }

      this.isLoading = true;

      const ok = await OrdersService.add(this.localOrder)

      if (ok === true) {
        this.$core.dialogs.OrderCreateDialogMinimized.resolve();
      }

      this.isLoading = false;
    },

    copyLink(): void {
      this.$core.utils.copyToClipboard(this.localOrder.positions[0].layoutFile);
      this.$core.showNotification.success('Скопировано в буфер обмена');
    },
  },
});
</script>
